import { render, staticRenderFns } from "./HelpPhases.vue?vue&type=template&id=1cc41d1e"
import script from "./HelpPhases.vue?vue&type=script&lang=ts"
export * from "./HelpPhases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports